var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      staticClass: "__pop-nutritional",
      attrs: {
        title: "营养成分表",
        width: "780px",
        top: "10vh",
        center: true,
        visible: _vm.isShow,
        "append-to-body": true,
      },
      on: {
        close: _vm.closePop,
        "update:visible": function ($event) {
          _vm.isShow = $event
        },
      },
    },
    [
      _c(
        "div",
        { staticClass: "content-box" },
        [
          _c(
            "div",
            { staticClass: "table-box" },
            [
              _c("div", { staticClass: "tr-box" }, [
                _c("div", { staticClass: "th-box th-border" }, [
                  _vm._v("成分"),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "th-box th-border" }, [
                  _vm._v("含量"),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "th-box th-border" }, [
                  _vm._v("功效"),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "th-box th-border" }, [
                  _vm._v("操作"),
                ]),
              ]),
              _vm._v(" "),
              _vm.nutritionalList.length > 0
                ? _vm._l(_vm.nutritionalList, function (item, index) {
                    return _c("div", { key: item.id, staticClass: "tr-box" }, [
                      _c("div", { staticClass: "td-box td-border" }, [
                        _c("div", {
                          staticClass: "rich-box",
                          attrs: {
                            id: "component-" + item.id,
                            contenteditable: "",
                          },
                          on: {
                            input: function ($event) {
                              return _vm.listenComponent($event, index)
                            },
                          },
                        }),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "td-box td-border" }, [
                        _c("div", {
                          staticClass: "rich-box",
                          attrs: {
                            id: "content-" + item.id,
                            contenteditable: "",
                          },
                          on: {
                            input: function ($event) {
                              return _vm.listenContent($event, index)
                            },
                          },
                        }),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "td-box td-border" }, [
                        _c("div", {
                          staticClass: "rich-box",
                          attrs: {
                            id: "efficacy-" + item.id,
                            contenteditable: "",
                          },
                          on: {
                            input: function ($event) {
                              return _vm.listenEfficacy($event, index)
                            },
                          },
                        }),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "td-box td-border" },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { size: "small", type: "primary" },
                              on: {
                                click: function ($event) {
                                  return _vm.addRow(index)
                                },
                              },
                            },
                            [_vm._v("添加行")]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              attrs: { size: "small", type: "danger" },
                              on: {
                                click: function ($event) {
                                  return _vm.deleteRow(index)
                                },
                              },
                            },
                            [_vm._v("删除行")]
                          ),
                        ],
                        1
                      ),
                    ])
                  })
                : _vm._e(),
            ],
            2
          ),
          _vm._v(" "),
          _vm.nutritionalList.length == 0
            ? [
                _c(
                  "div",
                  { staticClass: "table-empty-box" },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { size: "small", type: "primary" },
                        on: {
                          click: function ($event) {
                            return _vm.addRow(-1)
                          },
                        },
                      },
                      [_vm._v("添加一行")]
                    ),
                  ],
                  1
                ),
              ]
            : _vm._e(),
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "btn-box", attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "div",
            { staticClass: "btn-item cancel-btn", on: { click: _vm.closePop } },
            [_vm._v("关闭")]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "btn-item sure-btn", on: { click: _vm.onSubmit } },
            [_vm._v("确定")]
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }